import type { JSONContent } from '@tiptap/core';
import { applyTextNodesByKey } from '@duke-hq/shared-constants/translationSegmentExtract';
import type { RouterOutputs } from '@duke-hq/app-admin-web/lib/trpcAdmin';

type ExtractedSegment =
  RouterOutputs['translationOverrides']['extractSegments']['segments'][number];

export type PartialTranslation = {
  content: JSONContent;
  translatedCount: number;
  editedCount: number;
};

// Per-segment overlay of the published translation onto the (possibly edited)
// draft: matched segments show the machine translation, the rest stay English
// and flagged. Overrides are ignored (machine-only preview). Blank machine
// values are left out of the map so an untranslated segment flags like an edit.
export function translateDocumentPartial(
  content: JSONContent,
  segments: ExtractedSegment[],
): PartialTranslation {
  const valuesByKey = new Map<string, string>();
  for (const segment of segments) {
    const machine = segment.currentMachineValue ?? '';
    if (machine.trim() !== '') {
      valuesByKey.set(segment.segmentKey, machine);
    }
  }
  return applyTextNodesByKey(content, valuesByKey);
}
